import HyperlinkBox from "./HyperlinkBox";

export default HyperlinkBox;



// WEBPACK FOOTER //
// ./src/components/DocumentItems/HyperlinkBox/index.js